import { hebrewLOT } from './hebrew_lib'

// Prefix characters that require a following character to complete the pattern
// ; = rare cantillation, : = less common cantillation, / = common cantillation, h = hataf vowels
export const HEBREW_PREFIXES = ['$', '@'];

function replaceChars(str: string, map: any[]) {
    map.forEach((_, regexItem) => {
        str = str.replace(map[regexItem].match, map[regexItem].replace);
    });
    return str;
}

export const EnglishToHebrew = (text: string): string => {
    return replaceChars(text, hebrewLOT);
};
